import React, { Suspense, lazy } from 'react';

const { REACT_APP_BUILD_ENV } = process.env;

const appMap = {
    manager: lazy(_ => import('../ManagerNav')),
    submit:  lazy(_ => import('../SubmitNav')),
    dev: lazy(_ => import('./localDev'))
};

const Content = appMap[REACT_APP_BUILD_ENV];

function NavRoutes () {
    return (
        <Suspense fallback={<div>loading app...</div>}>
            <Content />
        </Suspense>
    );
}

export default NavRoutes;
